<!-- filter-dropdown.component.html -->
<div class="w-full relative">
  <!-- Label -->
  <label *ngIf="showlabel" class="block text-sm font-medium text-gray-700 mb-1">
    {{ label }}
    <span *ngIf="required" class="text-red-500">*</span>
  </label>

  <!-- Dropdown Button -->
  <button
    type="button"
    (click)="toggleDropdown($event)"
    class="dropdown-select dark:disabled:!bg-secondary pr-3"
    [class.border-red-500]="required && formControl?.errors?.['required'] && formControl?.touched"
    [ngClass]="customClass"
    [disabled]="disabled"
  >
    <div class="flex justify-between items-center">
      <span class="block truncate">
        {{ selectedOption ? selectedOption['name'] : placeholder }}
      </span>
      <!-- Dropdown Arrow -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        [class.rotate-180]="isOpen"
        class="text-gray-400 hover:text-gray-600 transition-transform duration-200"
      >
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    </div>
  </button>

  <!-- Dropdown Options -->
  <div *ngIf="isOpen" class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
    <div
      *ngFor="let option of options"
      (click)="selectOption(option)"
      class="relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 hover:bg-blue-royal group"
    >
      <span class="block truncate group-hover:text-white">
        {{ option['name'] }}
      </span>

      <!-- Check mark for selected option -->
      <span
        *ngIf="selectedOption && selectedOption['id'] === option['id']"
        class="absolute inset-y-0 right-0 flex items-center pr-4 text-blue-royal group-hover:text-white"
      >
        <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
        </svg>
      </span>
    </div>
  </div>
</div>
